export function generateQueryString(params, isSubKey = false, keyPrefix = '') {
    return Object
        .keys(params)
        .filter(k => params[k] != undefined)
        .map(k => {
            let key = encodeURIComponent(k);
            if(isSubKey) {
                key = '[' + key + ']';
            }
            key = keyPrefix + key;

            if (Array.isArray(params[k])) {
                return params[k]
                    .map(val => `${key}[]=${encodeURIComponent(val)}`)
                    .join('&');
            } else if(params[k] && typeof params[k] == 'object') {
                return generateQueryString(params[k], true, key);
            }

            return `${key}=${encodeURIComponent(params[k])}`
        })
        .join('&');
}

export function replaceUrlVars(url, vars) {
    const unusedUrlVars = Object.assign({}, vars);

    Object.keys(vars).forEach(key => {
        url = url.replace(`%${key}%`, () => {
            delete unusedUrlVars[key];

            return vars[key];
        });
    });

    return unusedUrlVars;
}